module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.giveUpRegistModal
    },
    attrs: {
      "id": "give-up-regist-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container"
  }, [_c('div', {
    staticClass: "table-wrap border-top-none mt-0"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("중도포기 등록 정보 테이블")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("사업연도")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.BIZ_YEAR))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("세부사업명")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.detail.BIZNM))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("참여자 단계")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.curStatCdNm))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("중도포기일")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area mo-size wid200"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveupDate),
      expression: "giveupDate"
    }],
    attrs: {
      "type": "date",
      "max": "9999-12-31",
      "title": "중도포기일"
    },
    domProps: {
      "value": (_vm.giveupDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.giveupDate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("포기사유")]), _vm._v(" "), _c('td', [(_vm.annKindType === 'JB') ? _c('div', {
    staticClass: "radio-group"
  }, [_c('label', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveupRsn),
      expression: "giveupRsn"
    }],
    attrs: {
      "type": "radio",
      "name": "give-up",
      "value": "1",
      "title": "give-up 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.giveupRsn, "1")
    },
    on: {
      "change": function($event) {
        _vm.giveupRsn = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                    취업\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveupRsn),
      expression: "giveupRsn"
    }],
    attrs: {
      "type": "radio",
      "name": "give-up",
      "value": "2",
      "title": "give-up 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.giveupRsn, "2")
    },
    on: {
      "change": function($event) {
        _vm.giveupRsn = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                    창업\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveupRsn),
      expression: "giveupRsn"
    }],
    attrs: {
      "type": "radio",
      "name": "give-up",
      "value": "3",
      "title": "give-up 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.giveupRsn, "3")
    },
    on: {
      "change": function($event) {
        _vm.giveupRsn = "3"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                    개인사유\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveupRsn),
      expression: "giveupRsn"
    }],
    attrs: {
      "type": "radio",
      "name": "give-up",
      "value": "0",
      "title": "give-up 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.giveupRsn, "0")
    },
    on: {
      "change": function($event) {
        _vm.giveupRsn = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                    기타\n                  ")])]) : _c('div', {
    staticClass: "radio-group"
  }, _vm._l((_vm.giveupRsnCodes), function(item) {
    return _c('label', {
      key: item.code,
      staticClass: "radio-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.giveupRsn),
        expression: "giveupRsn"
      }],
      attrs: {
        "type": "radio",
        "name": "give-up",
        "title": "give-up 선택"
      },
      domProps: {
        "value": item.code,
        "checked": _vm._q(_vm.giveupRsn, item.code)
      },
      on: {
        "change": function($event) {
          _vm.giveupRsn = item.code
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-radio"
    }), _vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("포기사유 상세")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area wid100p"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meanGiveupRsn),
      expression: "meanGiveupRsn"
    }],
    attrs: {
      "type": "text",
      "title": "포기사유 상세"
    },
    domProps: {
      "value": (_vm.meanGiveupRsn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.meanGiveupRsn = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        닫기\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.giveupRegist
    }
  }, [_vm._v("\n        저장하기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("중도포기 등록")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be5b7f6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/GiveUpRegist.vue
// module id = 1509
// module chunks = 6